<template lang="pug" >
div
  span 测试卡槽数据:
  el-table(:data="tableData" style="width: 100%")
    el-table-column(prop="date" label="日期" )
    el-table-column(prop="name" label="姓名" )
    el-table-column(prop="address" label="地址" )
  //- el-button(type="primary" @click="open") 主要按钮
</template>

<script>
export default {
  props: {
    // 流程信息
    flowMessage: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    };
  },
  methods: {
    getFormData() {
      return {
        column292: this.tableData
      };
    },
    setFormData(val) {
      console.log("val", val);
      this.tableData = val.column292;
    },
    open() {
      console.log(this.flowMessage);
      debugger;
    }
  }

};
</script>

<style>

</style>
